import React from 'react';
import PropTypes from 'prop-types';

const EndOfReport = ({ value, onChange }) => [
  <strong key='title'>
    End Of Report
  </strong>,
  <p key='description'>
    The text will display on the last page of this report
  </p>,
  <textarea
    value={value}
    onChange={onChange}
    key='content'
    className='form-control'
    rows={9}
  />
];

EndOfReport.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func
};


export default EndOfReport;


// WEBPACK FOOTER //
// src/components/reportLayout/EndOfReport/index.jsx